var setloyaltydataResponse = {
  "Success": true,
  "Data": {
    "Id": "CBDigitalCart980c724d47fa473ea94b57a6d456ef57brandsite",
    "CartLines": [{
      "Id": "c4a5ff01fe304c05b65c0b1ffe747cc0",
      "Product": {
        "SitecoreId": "26cccc11-fd93-56e0-18f9-228feb4ebe31",
        "ProductChainId": "486077",
        "StoreProductId": "16395154",
        "ProductVariantId": null,
        "DisplayName": "Bottled Root Beer",
        "AvailableInventory": 0,
        "CurrencySymbol": "USD",
        "ListPrice": 0,
        "AdjustedPrice": null,
        "ImageFilePath": "https://olo-images-sandbox.imgix.net/85/85f9e54d294d46ef82c1cd2aef9884bc.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=585945ade9b3eee2a659ddc7c7ac9d83",
        "MinimumQuantity": "1",
        "MaximumQuantity": "0",
        "MinimumBasketQuantity": "0",
        "MaximumBasketQuantity": "0",
        "DetailLink": "/menu/drinks/sodas/bottled-root-beer?productid=16395154",
        "CatalogName": "CB_Food_Store",
        "ProductVariantModel": null,
        "AdvanceNoticeTimeInHours": "0"
      },
      "Quantity": 1,
      "Price": {
        "CurrencyCode": "USD",
        "CurrencySymbol": "$",
        "Total": 0,
        "Subtotal": 3.1900,
        "HandlingTotal": 0,
        "ShippingTotal": 0,
        "TaxTotal": 0,
        "TotalSavings": 0,
        "OloTip": null,
        "OloCateringTip": null
      },
      "Options": null,
      "LineCost": 3.1900,
      "OloBasketId": "daf6360a-7eb2-4657-9391-0b8e0e889326",
      "OloBasketProductId": "10039665019",
      "Recipient": null,
      "SpecialInstruction": null,
      "LineOptions": null,
      "TrackingNumber": null,
      "AddOnProductDetails": null,
      "ReturnDetails": {
        "Quantity": 0,
        "ReturnWindowExpired": false,
        "Status": "",
        "IsReturnInitiated": false,
        "Reason": ""
      }
    }, {
      "Id": "5ea4e606ae134f89a4ebcf42b59e34c2",
      "Product": {
        "SitecoreId": "4ddabf7c-ef37-2a16-ae56-594e53878527",
        "ProductChainId": "486321",
        "StoreProductId": "16395169",
        "ProductVariantId": null,
        "DisplayName": "Double Chocolate Fudge Coca-Cola® Cake",
        "AvailableInventory": 0,
        "CurrencySymbol": "USD",
        "ListPrice": 0,
        "AdjustedPrice": null,
        "ImageFilePath": "https://olo-images-sandbox.imgix.net/6e/6eac9f6a7f14488683302898e69451d2.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=7713f4d4b94e623fcde302bdde707d23",
        "MinimumQuantity": "1",
        "MaximumQuantity": "0",
        "MinimumBasketQuantity": "0",
        "MaximumBasketQuantity": "0",
        "DetailLink": "/menu/sweets/candy/double-chocolate-fudge-coca-cola®-cake?productid=16395169",
        "CatalogName": "CB_Food_Store",
        "ProductVariantModel": null,
        "AdvanceNoticeTimeInHours": "0"
      },
      "Quantity": 1,
      "Price": {
        "CurrencyCode": "USD",
        "CurrencySymbol": "$",
        "Total": 0,
        "Subtotal": 4.9900,
        "HandlingTotal": 0,
        "ShippingTotal": 0,
        "TaxTotal": 0,
        "TotalSavings": 0,
        "OloTip": null,
        "OloCateringTip": null
      },
      "Options": null,
      "LineCost": 4.9900,
      "OloBasketId": "daf6360a-7eb2-4657-9391-0b8e0e889326",
      "OloBasketProductId": "10039665020",
      "Recipient": null,
      "SpecialInstruction": null,
      "LineOptions": null,
      "TrackingNumber": null,
      "AddOnProductDetails": null,
      "ReturnDetails": {
        "Quantity": 0,
        "ReturnWindowExpired": false,
        "Status": "",
        "IsReturnInitiated": false,
        "Reason": ""
      }
    }],
    "Price": {
      "CurrencyCode": "USD",
      "CurrencySymbol": "$",
      "Total": 8.9800,
      "Subtotal": 8.1800,
      "HandlingTotal": 0,
      "ShippingTotal": 0,
      "TaxTotal": 0.80,
      "TotalSavings": 0,
      "OloTip": 0.0,
      "OloCateringTip": 0.0
    },
    "Adjustments": [],
    "Email": null,
    "Addresses": [{
      "Name": "",
      "FirstName": "",
      "LastName": "",
      "Address1": "",
      "Address2": "",
      "Country": "",
      "CountryCode": "",
      "City": "",
      "State": "",
      "ZipPostalCode": "",
      "ExternalId": "",
      "PartyId": "",
      "IsPrimary": false,
      "Email": "",
      "ContactId": null
    }],
    "Shippings": null,
    "Options": null,
    "OloFoodStoreBasketId": "daf6360a-7eb2-4657-9391-0b8e0e889326",
    "OloCateringStoreBasketId": null,
    "OloErrors": null,
    "FoodDelivery": {
      "EatDelivery": {
        "Address": {
          "Building": null,
          "StreetAddress": null,
          "City": null,
          "Zipcode": null,
          "PhoneNumber": null,
          "SpecialInstructions": null
        },
        "Mode": "curbside",
        "TimeMode": null,
        "TimeWanted": null,
        "EarliestReadyTime": "20230726 17:54",
        "LeadTimeEstimateMinutes": 10,
        "DeliveryCharge": 0.0
      },
      "CaterDelivery": {
        "Address": {
          "Building": null,
          "StreetAddress": null,
          "City": null,
          "Zipcode": null,
          "PhoneNumber": null,
          "SpecialInstructions": null
        },
        "Mode": null,
        "TimeMode": null,
        "TimeWanted": null,
        "EarliestReadyTime": null,
        "LeadTimeEstimateMinutes": 0,
        "DeliveryCharge": 0.0
      }
    },
    "OloDiscount": null,
    "OloStoreComponent": null,
    "UserIp": "154.9.0.54",
    "DisplayMessages": [],
    "UpsellCrossSellCategories": null,
    "IsTokenExEnabled": true
  },
  "Errors": []
};
var giftCardBalanceResponse = {
  'Id': 'CBDigitalCartcbdad503-72e7-45f2-9727-6e0c58112049brandsite',
  'CartLines': [{
    'Id': '2bcfb4c2164843c1b0a8e9d165bc63b1',
    'Product': {
      'SitecoreId': '610b982b-cd43-2218-b7ad-9b31a6d9e9e0',
      'ProductChainId': '204205',
      'StoreProductId': '55753700',
      'ProductVariantId': null,
      'DisplayName': 'Freshly Brewed Unsweetened Iced Tea (Half Gallon)',
      'AvailableInventory': 0,
      'CurrencySymbol': 'USD',
      'ListPrice': 0,
      'AdjustedPrice': null,
      'ImageFilePath': 'https://olo-images-live.imgix.net/ef/ef937c662b6a4d60952a74bdaed6e82a.jpg?auto=format%2Ccompress&q=60&cs=tinysrgb&w=528&h=352&fit=fill&fm=png32&bg=transparent&s=536e57f8c4d7a11c2274eaf05193fb9c',
      'MinimumQuantity': '1',
      'MaximumQuantity': '0',
      'MinimumBasketQuantity': '0',
      'MaximumBasketQuantity': '0',
      'DetailLink': '/menu/beverages/teas-and-lemonade/freshly-brewed-unsweetened-iced-tea-half-gallon?productid=55753700',
      'CatalogName': 'CB_Food_Store',
      'ProductVariantModel': null,
      'AdvanceNoticeTimeInHours': '0'
    },
    'Quantity': 1,
    'Price': {
      'CurrencyCode': 'USD',
      'CurrencySymbol': '$',
      'Total': 0,
      'GiftCardTotal': null,
      'Subtotal': 4.9900,
      'HandlingTotal': 0,
      'ShippingTotal': 0,
      'TaxTotal': 0,
      'TotalSavings': 0,
      'OloTip': null,
      'OloCateringTip': null
    },
    'Options': null,
    'LineCost': 4.9900,
    'OloBasketId': '5b61bb49-19fe-472d-addd-71fb2824337a',
    'OloBasketProductId': '16877253759',
    'Recipient': null,
    'SpecialInstruction': null,
    'LineOptions': null,
    'TrackingNumber': null,
    'AddOnProductDetails': null,
    'ReturnDetails': {
      'Quantity': 0,
      'ReturnWindowExpired': false,
      'Status': '',
      'IsReturnInitiated': false,
      'Reason': ''
    }
  }],
  'Price': {
    'CurrencyCode': 'USD',
    'CurrencySymbol': '$',
    'Total': 0.00,
    'GiftCardTotal': 5.4500,
    'Subtotal': 4.9900,
    'HandlingTotal': 0,
    'ShippingTotal': 0,
    'TaxTotal': 0.46,
    'TotalSavings': 0,
    'OloTip': 0.0,
    'OloCateringTip': 0.0
  },
  'Adjustments': [],
  'Email': null,
  'Addresses': [{
    'Name': '',
    'FirstName': '',
    'LastName': '',
    'Address1': '',
    'Address2': '',
    'Country': '',
    'CountryCode': '',
    'City': '',
    'State': '',
    'ZipPostalCode': '',
    'ExternalId': '',
    'PartyId': '',
    'IsPrimary': false,
    'Email': '',
    'ContactId': null
  }],
  'Shippings': null,
  'Options': null,
  'OloFoodStoreBasketId': '5b61bb49-19fe-472d-addd-71fb2824337a',
  'OloCateringStoreBasketId': null,
  'OloErrors': null,
  'FoodDelivery': {
    'EatDelivery': {
      'Address': {
        'Building': null,
        'StreetAddress': null,
        'City': null,
        'Zipcode': null,
        'PhoneNumber': null,
        'SpecialInstructions': null
      },
      'Mode': 'curbside',
      'TimeMode': null,
      'TimeWanted': null,
      'EarliestReadyTime': '20230720 16:45',
      'LeadTimeEstimateMinutes': 20,
      'DeliveryCharge': 0.0
    },
    'CaterDelivery': {
      'Address': {
        'Building': null,
        'StreetAddress': null,
        'City': null,
        'Zipcode': null,
        'PhoneNumber': null,
        'SpecialInstructions': null
      },
      'Mode': null,
      'TimeMode': null,
      'TimeWanted': null,
      'EarliestReadyTime': null,
      'LeadTimeEstimateMinutes': 0,
      'DeliveryCharge': 0.0
    }
  },
  'OloDiscount': null,
  'OloStoreComponent': null,
  'UserIp': '127.0.0.1',
  'DisplayMessages': [],
  'UpsellCrossSellCategories': null,
  'GiftCardDetails': {
    'Balance': 30,
    'Message': 'This card has a balance less than $1.00. Check your card number and pin again or a use a different gift card.',
    'Success': true,
    'SupportsTip': true
  },
  'IsTokenExEnabled': true
};
var billingSchemes = {
  "BillingSchemes": [{
    "Id": 2,
    "Name": "Pay Restaurant Directly",
    "Type": "payinstore"
  }, {
    "Id": 1,
    "Name": "Credit Card",
    "Type": "creditcard"
  }, {
    "Id": 1433,
    "Name": "Apple Pay",
    "Type": "external"
  }, {
    "Id": 1434,
    "Name": "Google Pay Direct",
    "Type": "external"
  }, {
    "Id": 147,
    "Name": "Cracker Barrel Mock Gift",
    "Type": "giftcard"
  }],
  "errorMessage": null
};
export { setloyaltydataResponse, giftCardBalanceResponse, billingSchemes };